import { exists } from '@/api'
import { dataStore } from '@/utils/store-accessor'

export interface BibliographyTooli {
  marcNo: string
  seriesId: string
  stockStatus: string
  setFlag: string
  bibStatus: string
  contentsFlag: string
  learnFlag: string
  title1: string
  title2: string
  title3: string
  series: string
  author: string
  pubYear: string
  page: string
  size: string
  vol: string
  distinction: string
  ndc8: string
  ndc9: string
  ndc10: string
  pictureBookNdc8: string
  pictureBookNdc9: string
  pictureBookNdc10: string
  bookSign: string
  volSign: string
  price: string
  bellCode: string
  sinkeizokuCode: string
  stockBooks: string
  isbn: string
  publisher: string
  subject: string
  edition: string
  notes: string
  content: string
  authorIntroduction: string
  genre: string
  freq: string
  freqOther: string
  docClass: string
  docForm: string
  target: string
  distributionCount: string
  guidNumber: string
  binding: string
  lang: string
  prize: string
  originalTitle: string
  inputMaterialFormat: {
    // API側から渡されてくる値ではないが、こちらで管理した方が都合が良いので対応
    input: string
    errorMessage: string
  }
}

export const defaultBibliographyTooli = (): BibliographyTooli => ({
  marcNo: '',
  seriesId: '',
  stockStatus: '',
  setFlag: '',
  bibStatus: '',
  contentsFlag: '',
  learnFlag: '',
  title1: '',
  title2: '',
  title3: '',
  series: '',
  author: '',
  pubYear: '',
  page: '',
  size: '',
  vol: '',
  distinction: '',
  ndc8: '',
  ndc9: '',
  ndc10: '',
  pictureBookNdc8: '',
  pictureBookNdc9: '',
  pictureBookNdc10: '',
  bookSign: '',
  volSign: '',
  price: '',
  bellCode: '',
  sinkeizokuCode: '',
  stockBooks: '',
  isbn: '',
  publisher: '',
  subject: '',
  edition: '',
  notes: '',
  content: '',
  authorIntroduction: '',
  genre: '',
  freq: '',
  freqOther: '',
  docClass: '',
  docForm: '',
  target: '',
  distributionCount: '',
  guidNumber: '',
  binding: '',
  lang: '',
  prize: '',
  originalTitle: '',
  inputMaterialFormat: {
    input: dataStore.defaultBibliographyDetailTooliDownloadMaterialFormat,
    errorMessage: ''
  }
})

export function BibliographyTooliFromJSON(json: any): BibliographyTooli {
  return {
    marcNo: exists(json, 'marc_no') ? json.marc_no : '',
    seriesId: exists(json, 'series_id') ? json.series_id : '',
    stockStatus: exists(json, 'stock_status') ? json.stock_status : '',
    setFlag: exists(json, 'set_flag') ? json.set_flag : '',
    bibStatus: exists(json, 'bib_status') ? json.bib_status : '',
    contentsFlag: exists(json, 'contents_flag') ? json.contents_flag : '',
    learnFlag: exists(json, 'learn_flag') ? json.learn_flag : '',
    title1: exists(json, 'title1') ? json.title1 : '',
    title2: exists(json, 'title2') ? json.title2 : '',
    title3: exists(json, 'title3') ? json.title3 : '',
    series: exists(json, 'series') ? json.series : '',
    author: exists(json, 'author') ? json.author : '',
    pubYear: exists(json, 'pub_year') ? json.pub_year : '',
    page: exists(json, 'page') ? json.page : '',
    size: exists(json, 'size') ? json.size : '',
    vol: exists(json, 'vol') ? json.vol : '',
    distinction: exists(json, 'distinction') ? json.distinction : '',
    ndc8: exists(json, 'ndc8') ? json.ndc8 : '',
    ndc9: exists(json, 'ndc9') ? json.ndc9 : '',
    ndc10: exists(json, 'ndc10') ? json.ndc10 : '',
    pictureBookNdc8: exists(json, 'picture_book_ndc8')
      ? json.picture_book_ndc8
      : '',
    pictureBookNdc9: exists(json, 'picture_book_ndc9')
      ? json.picture_book_ndc9
      : '',
    pictureBookNdc10: exists(json, 'picture_book_ndc10')
      ? json.picture_book_ndc10
      : '',
    bookSign: exists(json, 'book_sign') ? json.book_sign : '',
    volSign: exists(json, 'vol_sign') ? json.vol_sign : '',
    price: exists(json, 'price') ? json.price : '',
    bellCode: exists(json, 'bell_code') ? json.bell_code : '',
    sinkeizokuCode: exists(json, 'sinkeizoku_code') ? json.sinkeizoku_code : '',
    stockBooks: exists(json, 'stock_books') ? json.stock_books : '',
    isbn: exists(json, 'isbn') ? json.isbn : '',
    publisher: exists(json, 'publisher') ? json.publisher : '',
    subject: exists(json, 'subject') ? json.subject : '',
    edition: exists(json, 'edition') ? json.edition : '',
    notes: exists(json, 'notes') ? json.notes : '',
    content: exists(json, 'content') ? json.content : '',
    authorIntroduction: exists(json, 'author_introduction')
      ? json.author_introduction
      : '',
    genre: exists(json, 'genre') ? json.genre : '',
    freq: exists(json, 'freq') ? json.freq : '',
    freqOther: exists(json, 'freq_other') ? json.freq_other : '',
    docClass: exists(json, 'doc_class') ? json.doc_class : '',
    docForm: exists(json, 'doc_form') ? json.doc_form : '',
    target: exists(json, 'target') ? json.target : '',
    distributionCount: exists(json, 'distribution_count')
      ? json.distribution_count
      : '',
    guidNumber: exists(json, 'guid_number') ? json.guid_number : '',
    binding: exists(json, 'binding') ? json.binding : '',
    lang: exists(json, 'lang') ? json.lang : '',
    prize: exists(json, 'prize') ? json.prize : '',
    originalTitle: exists(json, 'original_title') ? json.original_title : '',
    inputMaterialFormat: {
      input: dataStore.defaultBibliographyDetailTooliDownloadMaterialFormat,
      errorMessage: ''
    }
  }
}
